import React, { Fragment } from 'react';
import { createPortal } from 'react-dom';
import Select from 'react-select';
import Tippy from '@tippyjs/react';
import $ from 'jquery';
import { EVENTS } from '../../utilities/CONSTANTS';
import { getApiDraftUsersUrlWithDraftId } from '../../utilities/urlHelper';

import ViewerAvatar from '../ViewerAvatar';

class ShareDraftModal extends React.Component {
    state = {
        users: null,
        selectedUsers: [],
        isSaving: false,
        message: null,
    };

    componentDidMount() {
        if (window._referencableTettraUsers) {
            return this.setUsers();
        }
        window.addEventListener(EVENTS.USERS_LOADED, this.setUsers);
    }

    componentWillUnmount() { return window.removeEventListener(EVENTS.USERS_LOADED, this.setUsers); }

    setUsers = () => {
        const users = window._referencableTettraUsers
            .map(u => ({ value: u.id, label: u.display_name }))
            .filter(u => (u.value && u.value !== window.userId));

        const selectedUsers = users.filter(u => (this.props.draftViewerIds.includes(u.value)));

        return this.setState({ users, selectedUsers });
    };

    handleSelectChange = (selectedOptions) => {
        const selectedUsers = selectedOptions || [];
        this.setState({ selectedUsers });
    };

    handleMessageChange = (e) => {
        const message = e.target.value;
        this.setState({ message });
    };

    handleSubmit = () => {
        const selectedUserIds = this.state.selectedUsers.map(u => u.value);
        const { message } = this.state;

        let isSaving = true;
        this.setState({ isSaving });

        $.ajax({
            type: 'POST',
            url: getApiDraftUsersUrlWithDraftId(window.draftId),
            data: {
                users: selectedUserIds,
                message,
                _token: window.csrfToken,
            },
        }).done(response => {
            this.props.updateViewers(window._tettraUsers.filter(u => selectedUserIds.includes(u.id)));
            isSaving = false;
            this.setState({ isSaving });
            this.props.closeModal();
        }).catch(e => (console.error(e)));
    };

    handleClick = (e) => {
        const { target } = e;
        if ($(target).hasClass('react-modal')) {
            this.props.closeModal();
        }
    };

    render() {
        const { users, selectedUsers, isSaving } = this.state;
        const btnDisabledClass = isSaving || !users ? 'is-disabled' : '';

        return createPortal(
            <div className="react-modal open" onMouseDown={this.handleClick}>
                <div className="modal-content">
                    <label className="h2 bold-3" htmlFor="draftViewers">Add draft viewers</label>
                    <p className="gray">Draft viewers can view a read-only version of this draft</p>
                    {users
                        ? (
                            <Fragment>
                                <div className="mt2 mb2">
                                    <Select
                                        id="draftViewers"
                                        name="draftViewers"
                                        value={selectedUsers}
                                        isMulti
                                        onChange={this.handleSelectChange}
                                        options={users}
                                        clearable
                                    />
                                </div>
                                <label className="h4 bold" htmlFor="draftMessage">Add a message</label>
                                <textarea
                                    id="draftMessage"
                                    className="field col-12 mt1"
                                    placeholder="optional"
                                    onChange={this.handleMessageChange}
                                />
                            </Fragment>
                        )
                        : (<div className="loading gray">Loading</div>)}
                    <div className="right-align mt3">
                        <span className="btn-secondary mr1" onMouseDown={this.props.closeModal}>Cancel</span>
                        <span
                            className={`btn btn-primary ${btnDisabledClass}`}
                            onMouseDown={this.handleSubmit}
                        >
                            {isSaving ? 'Saving...' : 'Share draft'}
                        </span>
                    </div>
                </div>
            </div>,
            document.body,
        );
    }
}

class AddViewersButton extends React.Component {
    render() {
        return (
            <Tippy content="Invite draft viewers" placement="bottom">
                <button
                    className="add-draft-viewers-btn"
                    onMouseDown={this.props.openModal}
                    type="button"
                    aria-label="Invite draft viewers"
                >
                    <span aria-hidden="true">+</span>
                </button>
            </Tippy>
        );
    }
}

class DraftSharingPermissions extends React.Component {
    state = {
        showModal: false,
        viewers: [],
    };

    componentDidMount() {
        if (window.draftId) {
            return $.get(getApiDraftUsersUrlWithDraftId(window.draftId))
                .then(({ draft_viewers: viewers }) => {
                    this.setState({ viewers });
                });
        }
        return this.setState({ viewers: [] });
    }

    updateViewers = (viewers) => this.setState({ viewers });

    openModal = () => this.setState({ showModal: true });

    closeModal = () => this.setState({ showModal: false });

    render() {
        const { showModal, viewers } = this.state;

        return (
            <Fragment>
                <AddViewersButton openModal={this.openModal} />
                { viewers.map(viewer => <ViewerAvatar user={viewer} key={`viewer-${viewer.id}`} />) }
                {showModal && <ShareDraftModal draftViewerIds={viewers.map(v => v.id)} closeModal={this.closeModal} updateViewers={this.updateViewers} />}
            </Fragment>
        );
    }
}

export default DraftSharingPermissions;
